'use client';

import { AbstractHttp, ServiceMethod } from '@app/libs/services/';

class RecaptchaService extends AbstractHttp {
  protected services = {
    googleVerify: {
      uri: '/recaptcha/google-verify',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        token: { required: true },
        remoteip: { required: false },
      },
    },
  };

  googleVerify(token: string, remoteip?: string) {
    return this.send('googleVerify', { params: { token, remoteip } });
  }
}

export const recaptchaService = new RecaptchaService();
